"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DownloadModal_1 = __importDefault(require("./DownloadModal"));
var DownloadItem_1 = __importDefault(require("./DownloadItem"));
var Snackbar_1 = __importStar(require("../snackbar/Snackbar"));
var fetch_1 = require("../../../../../../ww_project/Resources/Private/app/utility/fetch");
var cookie_utility_1 = require("../../../../../../ww_project/Resources/Private/app/utility/cookie_utility");
var constantsDownload_1 = require("../../data/constantsDownload");
/**
 * Download controller for communication between download components.
 *
 * @author Kevin Buchholz <kevin.buchholz@wendweb.de>
 */
var DownloadController = /** @class */ (function () {
    function DownloadController() {
        DownloadController._downloadModal = new DownloadModal_1.default(constantsDownload_1.DATA_DOWNLOAD_MODAL);
        document.querySelectorAll("[".concat(constantsDownload_1.DATA_PRODUCT_DOWNLOADS, "]")).forEach(function (element) {
            DownloadController._downloadItems.push(new DownloadItem_1.default(element));
        });
        DownloadController.downloadCounter = document.querySelectorAll("[".concat(constantsDownload_1.DATA_DOWNLOAD_COUNTER, "]"));
        DownloadController.downloadCounterWrapper = document.querySelectorAll("[".concat(constantsDownload_1.DATA_DOWNLOAD_COUNTER_WRAPPER, "]"));
        DownloadController.downloadModalBtn = document.querySelectorAll("[".concat(constantsDownload_1.DATA_DOWNLOAD_MODAL_OPEN, "]"));
        DownloadController.cookieUuid = cookie_utility_1.CookieUtility.getCookie('download_user_token');
        DownloadController.updateDownloadCartCount();
        DownloadController.checkForExistingItems();
    }
    /**
     * Add download object to cart.
     */
    DownloadController.addItem = function (downloadItem, downloadElement) {
        return __awaiter(this, void 0, void 0, function () {
            var filePath, customTitle, customThumbnail, url, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filePath = downloadElement.dataset.downloadPath;
                        customTitle = downloadElement.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_TITLE, "]")).innerHTML.trim();
                        customThumbnail = downloadElement.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_THUMBNAIL, "] img")).getAttribute('src');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        url = '?tx_wwdownloads_downloads[action]=ajaxAddFile' +
                            "&tx_wwdownloads_downloads[fileName]=".concat(filePath) +
                            "&tx_wwdownloads_downloads[customTitle]=".concat(customTitle) +
                            "&tx_wwdownloads_downloads[customThumbnail]=".concat(customThumbnail) +
                            "&tx_wwdownloads_downloads[uuid]=".concat(DownloadController.cookieUuid) +
                            '&type=100';
                        downloadItem.disableButtons(downloadElement);
                        return [4 /*yield*/, fetch_1.Fetch.fetchGetData(url)];
                    case 2:
                        response = _a.sent();
                        if (!response.success) return [3 /*break*/, 4];
                        return [4 /*yield*/, DownloadController.updateDownloadCartCount()];
                    case 3:
                        _a.sent();
                        downloadItem.enableButtons(downloadElement);
                        DownloadController._downloadModal.buildVisualItem(response);
                        DownloadController._downloadModal.checkIfCartEmpty(response.quantity);
                        downloadItem.updateButtonState(downloadElement, true);
                        Snackbar_1.default.trigger(Snackbar_1.SnackbarType.success, response.message);
                        return [3 /*break*/, 5];
                    case 4:
                        downloadItem.enableButtons(downloadElement);
                        Snackbar_1.default.trigger(Snackbar_1.SnackbarType.danger, "".concat(response.errorCode, ": ").concat(response.errorMessage));
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        downloadItem.enableButtons(downloadElement);
                        Snackbar_1.default.trigger(Snackbar_1.SnackbarType.danger, downloadItem.ErrorMessage);
                        console.log(e_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Remove item from cart.
     */
    DownloadController.removeItem = function (filePath, skipSnackbar) {
        return __awaiter(this, void 0, void 0, function () {
            var elementToCheck, downloadItemParent, str, fileName, url, response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        str = filePath.split('/');
                        fileName = str[str.length - 1];
                        // Get element and its button which has to be updated
                        DownloadController._downloadItems.forEach(function (element) {
                            var _a;
                            (_a = element.DownloadItems) === null || _a === void 0 ? void 0 : _a.forEach(function (downloadItem) {
                                if (fileName == downloadItem.dataset.downloadName) {
                                    elementToCheck = downloadItem;
                                    downloadItemParent = element;
                                }
                            });
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        url = '?tx_wwdownloads_downloads[action]=ajaxRemoveFile' +
                            "&tx_wwdownloads_downloads[fileName]=".concat(filePath) +
                            "&tx_wwdownloads_downloads[uuid]=".concat(DownloadController.cookieUuid) +
                            '&type=100';
                        return [4 /*yield*/, fetch_1.Fetch.fetchGetData(url)];
                    case 2:
                        response = _a.sent();
                        if (!response.success) return [3 /*break*/, 4];
                        // Update button state if it its on the same page
                        if (elementToCheck) {
                            downloadItemParent.updateButtonState(elementToCheck, false);
                        }
                        return [4 /*yield*/, DownloadController.updateDownloadCartCount()];
                    case 3:
                        _a.sent();
                        DownloadController._downloadModal.removeVisualItem(fileName);
                        DownloadController._downloadModal.checkIfCartEmpty(response.quantity);
                        if (!skipSnackbar) {
                            Snackbar_1.default.trigger(Snackbar_1.SnackbarType.success, response.message);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        Snackbar_1.default.trigger(Snackbar_1.SnackbarType.danger, "".concat(response.errorCode, ": ").concat(response.errorMessage));
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_2 = _a.sent();
                        Snackbar_1.default.trigger(Snackbar_1.SnackbarType.danger, downloadItemParent.ErrorMessage);
                        console.log(e_2);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Download all items in download cart.
     */
    DownloadController.downloadAllItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, byteCharacters, byteNumbers, i, byteArray, blob, data_1, link, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = '?tx_wwdownloads_downloads[action]=ajaxDownload' +
                            "&tx_wwdownloads_downloads[uuid]=".concat(DownloadController.cookieUuid) +
                            '&type=100';
                        return [4 /*yield*/, fetch_1.Fetch.fetchGetData(url)];
                    case 1:
                        response = _a.sent();
                        if (response.success) {
                            byteCharacters = atob(response.object.fileContent);
                            byteNumbers = new Array(byteCharacters.length);
                            for (i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            byteArray = new Uint8Array(byteNumbers);
                            blob = new Blob([byteArray], { type: response.object.contentType });
                            data_1 = window.URL.createObjectURL(blob);
                            link = document.createElement('a');
                            link.href = data_1;
                            link.download = response.object.fileName;
                            link.click();
                            setTimeout(function () {
                                window.URL.revokeObjectURL(data_1);
                            }, 100);
                            // Update all visual components
                            DownloadController.resetDownloadCartCount();
                            DownloadController._downloadModal.clearCart();
                            DownloadController._downloadItems.forEach(function (element) {
                                element.setButtonsInactive();
                            });
                        }
                        else {
                            Snackbar_1.default.trigger(Snackbar_1.SnackbarType.danger, "".concat(response.errorCode, ": ").concat(response.errorMessage));
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        console.log(e_3);
                        Snackbar_1.default.trigger(Snackbar_1.SnackbarType.danger, DownloadController._downloadItems[0].ErrorMessage);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Download single file.
     */
    DownloadController.downloadSingleItem = function (downloadItem, filePath, btn) {
        return __awaiter(this, void 0, void 0, function () {
            var path, fileName, btnElement, newBlob, data_2, link, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "".concat(window.location.origin, "/").concat(filePath);
                        fileName = filePath.split('/').pop().split('.')[0];
                        btnElement = btn;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // Add btn loading anim
                        btnElement.disabled = true;
                        btnElement.classList.add('is-loading');
                        return [4 /*yield*/, fetch(path).then(function (res) { return res.blob(); })];
                    case 2:
                        newBlob = _a.sent();
                        // Not a valid file
                        if (newBlob.type.includes('html')) {
                            Snackbar_1.default.trigger(Snackbar_1.SnackbarType.danger, downloadItem.ErrorMessage);
                            btnElement.disabled = false;
                            btnElement.classList.remove('is-loading');
                            return [2 /*return*/];
                        }
                        data_2 = window.URL.createObjectURL(newBlob);
                        link = document.createElement('a');
                        link.href = data_2;
                        link.download = fileName;
                        link.click();
                        // For Firefox, it is necessary to delay revoking the ObjectURL
                        setTimeout(function () {
                            window.URL.revokeObjectURL(data_2);
                        }, 100);
                        // Remove btn loading anim
                        btnElement.disabled = false;
                        btnElement.classList.remove('is-loading');
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        console.log(e_4);
                        Snackbar_1.default.trigger(Snackbar_1.SnackbarType.danger, downloadItem.ErrorMessage);
                        btnElement.disabled = false;
                        btnElement.classList.remove('is-loading');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update button states depending on existing cart items
     * @private
     */
    DownloadController.checkForExistingItems = function () {
        DownloadController._downloadItems.forEach(function (item) {
            var _a;
            (_a = item.DownloadItems) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
                DownloadController._downloadModal.CartItems.forEach(function (cartItem) {
                    if (element.dataset.downloadName == cartItem.dataset.downloadName) {
                        item.updateButtonState(element, true);
                    }
                });
            });
        });
    };
    /**
     * Update download cart count.
     * @private
     */
    DownloadController.updateDownloadCartCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response_1, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = '?tx_wwdownloads_downloads[action]=ajaxGetQuantity' +
                            "&tx_wwdownloads_downloads[uuid]=".concat(DownloadController.cookieUuid) +
                            '&type=100';
                        return [4 /*yield*/, fetch_1.Fetch.fetchGetData(url)];
                    case 1:
                        response_1 = _a.sent();
                        DownloadController.downloadCounter.forEach(function (element) {
                            element.innerHTML = response_1.quantity.toString();
                        });
                        DownloadController.downloadCounterWrapper.forEach(function (element) {
                            if (response_1.quantity < 1) {
                                element.classList.add('is-hidden');
                            }
                            else {
                                element.classList.remove('is-hidden');
                            }
                        });
                        if (response_1.quantity > 0) {
                            DownloadController.downloadModalBtn.forEach(function (element) {
                                element.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_FILLED, "]")).classList.remove('d-none');
                                element.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_EMPTY, "]")).classList.add('d-none');
                            });
                        }
                        else {
                            DownloadController.downloadModalBtn.forEach(function (element) {
                                element.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_FILLED, "]")).classList.add('d-none');
                                element.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_EMPTY, "]")).classList.remove('d-none');
                            });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _a.sent();
                        console.log(e_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Reset download cart icon and counter
     */
    DownloadController.resetDownloadCartCount = function () {
        DownloadController.downloadCounter.forEach(function (element) {
            element.innerHTML = '0';
        });
        DownloadController.downloadCounterWrapper.forEach(function (element) {
            element.classList.add('is-hidden');
        });
        DownloadController.downloadModalBtn.forEach(function (element) {
            element.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_FILLED, "]")).classList.add('d-none');
            element.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_EMPTY, "]")).classList.remove('d-none');
        });
    };
    DownloadController._downloadItems = [];
    return DownloadController;
}());
exports.default = DownloadController;
